<div class="u-shadow-mini" style="position: relative;">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span>
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					>
						<img class="downloadIcon" src="../../../../../assets/images/Download_Icon.svg" />
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div class="donut-chart-container" *ngIf="hasData">
					<div class="donut-legend-div">
						<div
							*ngFor="let legendItem of legendData; let i = index"
							class="legend-div"
							[ngClass]="currentLegend != legendItem ? 'legend-inactive' : ''"
							(click)="updateLegendData(legendItem)"
						>
							{{ legendItem }}
						</div>
					</div>
					<div class="outer-div">
						<div class="inner-div" *ngFor="let donut of currentChartData">
							<app-solidgauge-donut [chartData]="donut.series"></app-solidgauge-donut>
							<div class="donut-value">{{ donut.value | number }}</div>
							<div class="donut-title">{{ donut.title }}</div>
						</div>
					</div>
				</div>
				<div *ngIf="!hasData" class="no-data-demographics">
					<div class="no-data-text">No Data Available.</div>
				</div>
			</div>
		</div>
		<div class="device-table-widget demographics" *ngIf="hasData">
			<ngx-datatable
				class="datatable"
				[cssClasses]="cssClasses"
				[rows]="tableData"
				[columns]="columns"
				[sortType]="'single'"
				[columnMode]="'force'"
				[headerHeight]="50"
				[rowHeight]="'auto'"
				[limit]="10"
				[reorderable]="reorderable"
				[summaryRow]="true"
				[summaryPosition]="'bottom'"
				[summaryHeight]="'auto'"
			>
			</ngx-datatable>
		</div>
	</div>
</div>
